import React, { PureComponent } from 'react';
import ReactModal from 'react-modal';
import cx from 'classnames';
import PropTypes from 'prop-types';

export default class Modal extends PureComponent {
	static propTypes = {
		// The actual type of this prop is defined inside react-modal's internals
		// eslint-disable-next-line react/forbid-prop-types
		appElement: PropTypes.object,
		children: PropTypes.node.isRequired,
		className: PropTypes.string,
		contentLabel: PropTypes.string,
		overlayClassName: PropTypes.string,
		show: PropTypes.bool.isRequired,
		onCancel: PropTypes.func.isRequired
	};

	static defaultProps = {
		contentLabel: ''
	};

	render() {
		const {
			appElement,
			className,
			overlayClassName,
			show,
			onCancel,
			contentLabel,
			children
		} = this.props;

		return (
			<ReactModal
				appElement={appElement}
				ariaHideApp={!!appElement}
				className={cx('c-modal', className)}
				contentLabel={contentLabel}
				isOpen={show}
				overlayClassName={cx('c-modal-overlay', overlayClassName)}
				role="dialog"
				shouldCloseOnOverlayClick={true}
				onRequestClose={onCancel}>
				{children}
			</ReactModal>
		);
	}
}
